import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showSuccessToast = (message, options) => toast.success(message, { ...options });
export const showErrorToast = (message, options) => toast.error(message, { ...options });
export const showWarnToast = (message, options) => toast.warn(message, { ...options });
export const showInfoToast = (message, options) => toast.info(message, { ...options });
export const closeToast = () => toast.dismiss();
